import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import * as actions from './filtersActions';
import { type FiltersStore, mkFiltersStore } from './filtersTypes';

const reducer = handleActions<
  FiltersStore,
  | ReturnType<typeof actions.getFiltersSuccess>
  | ReturnType<typeof actions.createFilterSuccess>
  | ReturnType<typeof actions.updateFilterSuccess>
  | ReturnType<typeof actions.deleteFilterSuccess>
>(
  {
    [actions.getFiltersSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.createFilterSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.updateFilterSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.deleteFilterSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
  },
  mkFiltersStore(),
);

export default reducer;
